import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type SortIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const SortIcon = ({ ...props }: SortIconProps) => (
  <BaseIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V1C11 0.447715 11.4477 0 12 0Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 16C3.44772 16 3 15.5523 3 15L3 1C3 0.447715 3.44772 -1.35705e-07 4 -8.74228e-08C4.55229 -3.91405e-08 5 0.447715 5 1L5 15C5 15.5523 4.55228 16 4 16Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29289 11.2929C8.68342 10.9024 9.31658 10.9024 9.70711 11.2929L12 13.5858L14.2929 11.2929C14.6834 10.9024 15.3166 10.9024 15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70711 4.70711C7.31658 5.09763 6.68342 5.09763 6.29289 4.70711L4 2.41421L1.70711 4.70711C1.31658 5.09763 0.683417 5.09763 0.292893 4.70711C-0.0976309 4.31658 -0.0976309 3.68342 0.292894 3.29289L3.29289 0.292893C3.68342 -0.0976316 4.31658 -0.0976315 4.70711 0.292893L7.70711 3.29289C8.09763 3.68342 8.09763 4.31658 7.70711 4.70711Z"
      />
    </>
  </BaseIcon>
);

SortIcon.displayName = 'SortIcon';
